import { useMemo } from 'react'
import {
  TbAntennaBars1,
  TbAntennaBars2,
  TbAntennaBars3,
  TbAntennaBars4,
  TbAntennaBars5,
} from 'react-icons/tb'
import { useTranslation } from 'react-i18next'
import { useFilterValueCounts } from '../useFilterValueCounts'
import { MultiSelectCommandList } from './MultiSelectCommandList'
import type { ValuePickerProps } from './types'
import { cn } from '@/lib/utils'

function getPriorityIcon(priority: number) {
  const cls = 'size-3.5'
  switch (priority) {
    case 0:
      return <TbAntennaBars1 className={cn(cls, 'text-muted-foreground')} />
    case 1:
      return <TbAntennaBars2 className={cn(cls, 'text-blue-500')} />
    case 2:
      return <TbAntennaBars3 className={cn(cls, 'text-yellow-500')} />
    case 3:
      return <TbAntennaBars4 className={cn(cls, 'text-orange-500')} />
    case 4:
      return <TbAntennaBars5 className={cn(cls, 'text-red-500')} />
    default:
      return <TbAntennaBars1 className={cn(cls, 'text-muted-foreground')} />
  }
}

// Highest first, so "≥" reads down the list.
const PRIORITY_VALUES = [4, 3, 2, 1, 0]

export function PriorityFilterPicker({
  selectedValues,
  onToggleValue,
}: ValuePickerProps) {
  const { t } = useTranslation('tasks')
  const counts = useFilterValueCounts('priority')
  const options = useMemo(
    () =>
      PRIORITY_VALUES.map((value) => ({
        value,
        label: t(`filters.priorityLevels.${value}`),
        icon: getPriorityIcon(value),
      })),
    [t],
  )

  return (
    <MultiSelectCommandList
      options={options}
      selectedValues={selectedValues}
      onToggle={onToggleValue}
      searchPlaceholder={t('filters.search.priorities')}
      counts={counts}
    />
  )
}
